import Form from "../../utilities/script/form";
import Swal from "sweetalert2";
const downloadBrochure = new Form(document.querySelector("#download-brochure"));

Array.from(
  document.querySelectorAll('button[data-open-modal="download-brochure"]'),
).forEach((btn) => {
  btn.addEventListener("click", (event) => {
    const dataset = event.currentTarget.dataset;
    downloadBrochure.modal.querySelector("input[name=course-id]").value =
      dataset.courseId;
    downloadBrochure.modal.querySelector("input[name=request-type]").value =
      dataset.requestType;
    downloadBrochure.modal.querySelector("input[name=lsource]").value =
      dataset.lsource;
  });
});

// E book Submittion
downloadBrochure.validate.onSuccess(async (event) => {
  try {
    const formData = new FormData(event.target);
    formData.append("website-link", window.location.href);

    downloadBrochure.modal.classList.add("loading");

    let response = await fetch("/wp-content/themes/s2-labs/student-form.php", {
      body: formData,
      method: "POST",
    });

    if (!response.ok) throw Error("Something Went Wrong");

    let textData = await response.text();
    if (textData.indexOf("Technical Error") > 0) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong! Please try again after sometime...",
        icon: "error",
        confirmButtonText: "Close",
      });
      window.location.href =
        window.location.href + "?cachebuster=" + new Date().getTime();
      return false;
    }

    fbq("track", "CompleteRegistration");
    Swal.fire({
      title: "Thank you!",
      text: "You will receive the brochure on your email shortly.",
      icon: "success",
      confirmButtonText: "Close",
    });
  } catch {
    Swal.fire({
      title: "Error!",
      text: "Something went wrong! Please try again after sometime...",
      icon: "error",
      confirmButtonText: "Close",
    });
  } finally {
    downloadBrochure.modal.classList.remove("loading");
    downloadBrochure.modal.querySelector("form").reset();
    downloadBrochure.toggleModal();
  }
});
